export function deleteOutHoursButtons() {
  const observer = new MutationObserver((mutations, observer) => {
    if (
      document.querySelectorAll(
        '.footer-extras.mobile-options > .footer-option.nx-button--primary'
      ).length >= 3
    ) {
      const btnRemoveFueraDeHorario = document.querySelectorAll(
        '.footer-extras.mobile-options > .footer-option.nx-button--primary'
      )
      btnRemoveFueraDeHorario.forEach((selector) => {
        selector.style.display = 'none'
      })
    }
  })

  // Configurar el observador para observar cambios en el nodo body y sus descendientes
  observer.observe(document.body, { childList: true, subtree: true })
}
